"use client";

import AuthFooter from "@/components/auth/shared/AuthFooter";
import PhoneField from "@/components/auth/shared/PhoneField";
import { Button } from "@/components/ui/button";

type RegisterContentProps = {
  phone: string;
  onPhoneChange: (value: string) => void;
  onSubmit: (event?: React.BaseSyntheticEvent) => void;
  isSubmitting: boolean;
  errorMessage?: string;
  onLoginClick: () => void;
};

const RegisterContent = ({
  phone,
  onPhoneChange,
  onSubmit,
  isSubmitting,
  errorMessage,
  onLoginClick,
}: RegisterContentProps) => {
  const rawPhone = phone ? phone.replace(/\D/g, "") : "";
  const isSubmitDisabled = rawPhone.length < 8 || isSubmitting;

  return (
    <div className="mx-auto flex h-full w-full flex-col px-4 md:pb-0 pb-10">
      <form onSubmit={onSubmit} className="flex flex-col gap-4 sm:gap-6">
        <PhoneField
          label="Phone number"
          value={phone}
          onChange={onPhoneChange}
          errorMessage={errorMessage}
          inputMode="numeric"
        />

        <Button
          type="submit"
          size="xl"
          isLoading={isSubmitting}
          disabled={isSubmitDisabled}
        >
          Continue
        </Button>
      </form>

      <AuthFooter
        className="pt-5 sm:pt-10"
        prompt="Already have an account?"
        actionLabel="Sign In"
        onActionClick={onLoginClick}
      />
    </div>
  );
};

export default RegisterContent;
